//IMPORTS
import React from "react";

import "../../scss/ContactCard.scss";
import Avatar from "../../assets/images/avatar.png";

export const ContactCard = ({ employee }) => {
  //

  return (
    <div class='card_stack'>
      <div class='card__title'>
        <h1>{employee.title}</h1>
      </div>
      <div class='card__img'>
        <img src={Avatar} alt='Avatar' />
        <h2>{employee.name}</h2>
        <a href={employee.email}> {employee.email_show}</a>
      </div>
      <div class='card__phone'>
        <a href={employee.phone}> {employee.phone_show}</a>
      </div>
    </div>
  );
};
